@if (!listOnly()) {
  <div
    class="strip"
    role="group"
    aria-label="Days this week"
  >
    @for (cell of strip(); track cell.day) {
      <button
        type="button"
        class="strip-day"
        [class.is-selected]="selectedDay() === cell.day"
        [attr.aria-label]="cell.label"
        [attr.aria-pressed]="selectedDay() === cell.day"
        (click)="daySelected.emit(cell.day)"
      >
        <span
          class="weekday"
          aria-hidden="true"
          >{{ cell.weekday }}</span
        >
        <span
          class="num"
          [class.today]="cell.today"
          aria-hidden="true"
          >{{ cell.date }}</span
        >
        <span
          class="dots"
          aria-hidden="true"
        >
          @for (color of cell.dots; track $index) {
            <span
              class="dot"
              [style.background]="color"
            ></span>
          }
        </span>
      </button>
    }
  </div>

  @if (bars().bars.length) {
    <div
      class="bars"
      [style.grid-template-rows]="'repeat(' + bars().lanes + ', 24px)'"
    >
      @for (bar of bars().bars; track bar.entry.id) {
        <lib-timeline-bar
          [bar]="bar"
          [selected]="selectedId() === bar.entry.id"
          [style.grid-column]="bar.firstColumn + ' / ' + (bar.lastColumn + 1)"
          [style.grid-row]="bar.lane + 1"
          (selectEntry)="entrySelected.emit($event)"
        />
      }
    </div>
  }
}

<div class="agenda">
  @for (group of agenda(); track group.day) {
    <section
      class="group"
      [attr.aria-label]="group.title"
    >
      <h3 class="group-title">{{ group.title }}</h3>
      @for (entry of group.items; track entry.id) {
        <div class="item">
          <lib-timeline-chip
            [entry]="entry"
            touch
            [selected]="selectedId() === entry.id"
            (selectEntry)="entrySelected.emit($event)"
          />
          @if (entry.bar) {
            <span class="range">{{ rangeText(entry) }}</span>
          }
        </div>
      } @empty {
        <p class="empty">Nothing on this day.</p>
      }
    </section>
  } @empty {
    <p class="empty">Nothing this week.</p>
  }
</div>
